import { upperFirst } from '@mantine/hooks';

import { OTakedownStatus } from '../types';
import { parseMetisString } from '@/utils/metisUtils';

import type { ReactNode } from 'react';

import {
  HourglassIcon,
  CheckIcon,
  StarIcon,
  CancelIcon,
  DoneIcon,
  FeedbackIcon,
  InProgressIcon,
} from '../icons/StatusIcons';

import classes from './IncidentState.module.css';

const takedownStatusConfig: Record<
  string,
  { icon: ReactNode; color: string; bg: string; label: string }
> = {
  [OTakedownStatus.New]: {
    icon: <StarIcon />,
    color: '#e61342',
    bg: 'rgba(230, 19, 66, 0.1)',
    label: 'New',
  },
  [OTakedownStatus.Approved]: {
    icon: <DoneIcon />,
    color: '#0040ff',
    bg: 'rgba(0, 64, 255, 0.1)',
    label: 'Approved',
  },
  [OTakedownStatus.Pending]: {
    icon: <HourglassIcon />,
    color: '#0040ff',
    bg: 'rgba(0, 64, 255, 0.1)',
    label: 'Pending',
  },
  [OTakedownStatus.InProgress]: {
    icon: <InProgressIcon />,
    color: '#e89b0c',
    bg: 'rgba(232, 155, 12, 0.1)',
    label: 'In Progress',
  },
  [OTakedownStatus.Feedback]: {
    icon: <FeedbackIcon />,
    color: '#e89b0c',
    bg: 'rgba(232, 155, 12, 0.1)',
    label: 'Feedback',
  },
  [OTakedownStatus.Resolved]: {
    icon: <CheckIcon />,
    color: '#0dae2a',
    bg: 'rgba(13, 174, 42, 0.1)',
    label: 'Resolved',
  },
  [OTakedownStatus.Closed]: {
    icon: <CancelIcon />,
    color: '#777777',
    bg: 'rgba(163, 163, 163, 0.1)',
    label: 'Closed',
  },
  [OTakedownStatus.Rejected]: {
    icon: <CancelIcon />,
    color: '#e61342',
    bg: 'rgba(230, 19, 66, 0.1)',
    label: 'Rejected',
  },
};

interface TakedownStateProps {
  status?: string;
}

const TakedownState = ({ status }: TakedownStateProps) => {
  if (!status) {
    return null;
  }

  const parsed = parseMetisString(status);
  const config = takedownStatusConfig[parsed];

  if (!config) {
    return <span>{upperFirst(parsed)}</span>;
  }

  return (
    <span
      className={classes.chip}
      style={
        {
          '--chip-bg': config.bg,
          '--chip-color': config.color,
        } as React.CSSProperties
      }
    >
      <span className={classes.icon}>{config.icon}</span>
      {config.label}
    </span>
  );
};

export default TakedownState;
